// extracted by mini-css-extract-plugin
export default {"panel":"Relations_panel__Bpxkd"};